import './ox-input-nodes'
import './ox-property-editor-nodes'

export default [
  {
    type: 'nodes',
    element: 'ox-property-editor-nodes'
  }
]
